import * as XLSX from "xlsx";

const toNumber = (value) => Number(value) || 0;
const getSection = (items = [], key) => items.find((item) => item[key])?.[key] || {};

export const calculateTotals = (rows, checked) => {
  const totals = {
    memberTotalWL_all: 0,
    memberTotalCom_all: 0,
    memberTotal_all: 0,
    adminTotalWL_all: 0,
    adminTotalCom_all: 0,
    adminTotal_all: 0,
    companyTotalWL_all: 0,
    companyTotalCom_all: 0,
    companyTotal_all: 0,
    betAmount_all: 0,
  };

  const showAllTypes = !checked.mix && !checked.single;
  const showMix = checked.mix || showAllTypes;
  const showSingle = checked.single || showAllTypes;

  rows.forEach((row) => {
    const singleMember = getSection(row.member, "single");
    const mixMember = getSection(row.member, "mix");
    const singleAdmin = getSection(row.admin, "single");
    const mixAdmin = getSection(row.admin, "mix");
    const singleCompany = getSection(row.company, "single");
    const mixCompany = getSection(row.company, "mix");

    const memberTotalWL =
      (showMix ? toNumber(mixMember.wl) : 0) + (showSingle ? toNumber(singleMember.wl) : 0);
    const memberTotalCom =
      (showMix ? toNumber(mixMember.com) : 0) + (showSingle ? toNumber(singleMember.com) : 0);
    const memberTotal = memberTotalWL + memberTotalCom;

    const adminTotalWL =
      (showMix ? toNumber(mixAdmin.wl) : 0) + (showSingle ? toNumber(singleAdmin.wl) : 0);
    const adminTotalCom =
      (showMix ? toNumber(mixAdmin.com) : 0) + (showSingle ? toNumber(singleAdmin.com) : 0);
    const adminTotal = adminTotalWL + adminTotalCom;

    const companyTotalWL =
      (showMix ? toNumber(mixCompany.wl) : 0) + (showSingle ? toNumber(singleCompany.wl) : 0);
    const companyTotalCom =
      (showMix ? toNumber(mixCompany.com) : 0) + (showSingle ? toNumber(singleCompany.com) : 0);
    const companyTotal = companyTotalWL + companyTotalCom;

    totals.memberTotalWL_all += memberTotalWL;
    totals.memberTotalCom_all += memberTotalCom;
    totals.memberTotal_all += memberTotal;
    totals.adminTotalWL_all += adminTotalWL;
    totals.adminTotalCom_all += adminTotalCom;
    totals.adminTotal_all += adminTotal;
    totals.companyTotalWL_all += companyTotalWL;
    totals.companyTotalCom_all += companyTotalCom;
    totals.companyTotal_all += companyTotal;
    totals.betAmount_all += toNumber(row.amount);
  });

  return totals;
};

export const exportReport = (rows, startDate, endDate, type) => {
  const exportData = [];

  rows.forEach((r) => {
    const singleMember = getSection(r.member, "single");
    const mixMember = getSection(r.member, "mix");
    const singleAdmin = getSection(r.admin, "single");
    const mixAdmin = getSection(r.admin, "mix");
    const singleCompany = getSection(r.company, "single");
    const mixCompany = getSection(r.company, "mix");

    exportData.push({
      No: r.id,
      UserId: r.userId,
      Name: r.name,
      Amount: toNumber(r.amount),
      Type: "Single",
      "Member WL": toNumber(singleMember.wl),
      "Member Com": toNumber(singleMember.com),
      "Member Total": toNumber(singleMember.total),
      "Admin WL": toNumber(singleAdmin.wl),
      "Admin Com": toNumber(singleAdmin.com),
      "Admin Total": toNumber(singleAdmin.total),
      "Company WL": toNumber(singleCompany.wl),
      "Company Com": toNumber(singleCompany.com),
      "Company Total": toNumber(singleCompany.total),
    });

    exportData.push({
      No: "",
      UserId: "",
      Name: "",
      Amount: "",
      Type: "Mix",
      "Member WL": toNumber(mixMember.wl),
      "Member Com": toNumber(mixMember.com),
      "Member Total": toNumber(mixMember.total),
      "Admin WL": toNumber(mixAdmin.wl),
      "Admin Com": toNumber(mixAdmin.com),
      "Admin Total": toNumber(mixAdmin.total),
      "Company WL": toNumber(mixCompany.wl),
      "Company Com": toNumber(mixCompany.com),
      "Company Total": toNumber(mixCompany.total),
    });

    exportData.push({
      No: "",
      UserId: "",
      Name: "",
      Amount: "",
      Type: "Total",
      "Member WL": toNumber(mixMember.wl) + toNumber(singleMember.wl),
      "Member Com": toNumber(mixMember.com) + toNumber(singleMember.com),
      "Member Total": toNumber(mixMember.total) + toNumber(singleMember.total),
      "Admin WL": toNumber(mixAdmin.wl) + toNumber(singleAdmin.wl),
      "Admin Com": toNumber(mixAdmin.com) + toNumber(singleAdmin.com),
      "Admin Total": toNumber(mixAdmin.total) + toNumber(singleAdmin.total),
      "Company WL": toNumber(mixCompany.wl) + toNumber(singleCompany.wl),
      "Company Com": toNumber(mixCompany.com) + toNumber(singleCompany.com),
      "Company Total": toNumber(mixCompany.total) + toNumber(singleCompany.total),
    });
  });

  const ws = XLSX.utils.json_to_sheet(exportData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Profit");
  XLSX.writeFile(wb, `win_lose_report_${startDate}_${endDate}.${type}`);
};
